import styled from 'vue-styled-components'

const StyledRadioButton = styled.div`
  width: calc((100% - 8px) / 2);
  max-width: 224px; 
`

const StyledRadioButtonInput = styled.input`
  display: none;
`

const labelProps = {
  checked: Boolean
}

const StyledRadioButtonLabel = styled('label', labelProps)`
    display: flex;
    justify-content: center;
    align-items: center;

    height: 48px;
    padding: 0 5px;

    background-color: ${props => props.checked ? props.theme.colors.disabled : props.theme.colors.white};
    color: ${props => props.theme.colors.black};
    font-family: 'Gilroy';
    font-weight: ${props => props.theme.fontWeight.semiBold};
    font-size: 0.75rem;
    line-height: 1rem;
    text-align: center;
    cursor: pointer;
`

export {
  StyledRadioButton,
  StyledRadioButtonInput,
  StyledRadioButtonLabel
}



// WEBPACK FOOTER //
// ./src/components/RadioButton/StyledRadioButton.js